import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import PropTypes from 'prop-types';
import {rejectInvitation} from '../../actions';

class GroupInvitationsRejectButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      saving: false,
    };

    this.rejectInvitation = this.rejectInvitation.bind(this);
  }

  rejectInvitation(e){
    e.preventDefault();
    this.setState({saving: true});

    this.props.rejectInvitation(this.props.group.id)
      .then(() => {
        this.setState({
          modal: false,
          saving: false
        })
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { saving } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()}>
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="groupInvitationsRejectButton.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <FormattedMessage id="groupInvitationsRejectButton.modalBody" />
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="groupInvitationsRejectButton.button.reject">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={saving}
            data-style={ZOOM_OUT}
            onClick={this.rejectInvitation}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="" className="m-0 p-0" onClick={() => this.toggleModal()}><i className="fas fa-times" /></Button>
        {modal}
      </React.Fragment>
    )
  }
}

GroupInvitationsRejectButton.propTypes = {
  group: PropTypes.object.isRequired
};

export default connect(null, {rejectInvitation})(GroupInvitationsRejectButton);